import * as React from 'react';
import { useDispatch } from 'react-redux';
import { editGroup } from '../store/organization.store';
import { t } from '@moovly/i18n';
import { ModalContainer } from '@moovly/ui';
import { GroupInfo } from '@moovly/clients/lib/resources/group/group.interfaces';
import { DefaultModalProps } from '../../../types/modal';

interface EditOrganizationGroupModalProps extends DefaultModalProps {
  group: GroupInfo;
}

export const EditOrganizationGroupModal: React.FC<EditOrganizationGroupModalProps> = ({
  closeModal,
  setOpen,
  group,
}) => {
  const [name, setName] = React.useState('');
  const handleChangeName = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value), []);
  const dispatch = useDispatch<any>();
  const handleConfirm = React.useCallback(() => {
    if (!!group)
      dispatch(
        editGroup({
          groupId: group.id,
          name,
        })
      );
    closeModal();
  }, [dispatch, closeModal, group, name]);
  React.useEffect(() => {
    if (group) {
      setName(group.name);
    }
  }, [group]);

  return (
    <ModalContainer
      setOpen={setOpen}
      isOpen={!!group}
      title={t('groups.update.title')}
      onConfirm={handleConfirm}
      confirmButtonText={t('groups.update.button')}
    >
      <form onSubmit={handleConfirm}>
        <div>
          <div className="mb-3">
            <label htmlFor="libraryName" className="form-label">
              {t('groups.table.name')}
            </label>
            <input
              type="text"
              className="form-control"
              id="libraryName"
              onChange={handleChangeName}
              value={name}
              autoFocus
            />
          </div>
        </div>
      </form>
    </ModalContainer>
  );
};

export default EditOrganizationGroupModal;
